import emojiData from "emoji-datasource";

export const allEmojis = emojiData.map(e => ({
  emoji: String.fromCodePoint(...e.unified.split('-').map(c => parseInt(c, 16))),
  name: e.short_name
}));
